/* B commerce: reuses the verified F01 cart core from post-patch MAIN.
   Own B forms only; no Impulse hooks, tracking emitters, registry or polling. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (!root.RevalBCommerce) { root.RevalBCommerce = api; api.mount(root); }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var VARIANT = '51418024739111';
  var TEXT = 'Despacho estimado en 5–10 días hábiles. Envío exprés; el tránsito y la entrega dependen de la paquetería y el destino.';
  var PENDING_KEY = 'reval-f01-delivery-notice-v1';

  function isTarget(item) { return String(item.variant_id || item.id) === VARIANT; }
  function clone(value) { return JSON.parse(JSON.stringify(value)); }
  function stable(value) {
    if (Array.isArray(value)) return '[' + value.map(stable).join(',') + ']';
    if (value && typeof value === 'object') return '{' + Object.keys(value).sort().map(function (key) {
      return JSON.stringify(key) + ':' + stable(value[key]);
    }).join(',') + '}';
    return JSON.stringify(value);
  }
  function problem(code, message) { var error = new Error(message); error.code = code; return error; }
  function assertCart(cart) {
    if (!cart || !Array.isArray(cart.items) || cart.items.some(function (item) {
      return !item.key || !Number.isInteger(item.quantity) || item.quantity < 1;
    })) throw problem('invalid_cart', 'No pudimos leer el carrito completo. Vuelve a intentarlo.');
  }
  function correctedProperties(item) {
    var props = clone(item.properties || {});
    props.Entrega = TEXT;
    return props;
  }
  function itemSignature(item) {
    var record = {};
    ['variant_id', 'id', 'quantity', 'properties', 'selling_plan_allocation', 'parent_relationship',
      'price', 'original_price', 'final_price', 'line_price', 'original_line_price', 'final_line_price',
      'total_discount', 'discounts', 'line_level_discount_allocations', 'line_level_total_discount'].forEach(function (key) {
      if (key in item) record[key] = item[key];
    });
    record.properties = record.properties || {};
    return stable(record);
  }
  function cartSignature(cart) {
    var record = { items: cart.items.map(itemSignature).sort() };
    ['item_count', 'currency', 'note', 'attributes', 'total_price', 'original_total_price',
      'items_subtotal_price', 'total_discount', 'cart_level_discount_applications', 'discount_codes'].forEach(function (key) {
      if (key in cart) record[key] = cart[key];
    });
    return stable(record);
  }
  function preflight(cart) {
    assertCart(cart);
    var signatures = new Map();
    cart.items.filter(isTarget).forEach(function (item) {
      // The approved migration changes Entrega only. A distinct public legacy field
      // must not silently survive into checkout with a conflicting promise.
      var legacy = (item.properties || {})['Entrega estimada'];
      if (legacy && legacy !== TEXT) throw problem('legacy_property', 'Esta línea contiene otra promesa de entrega que necesita revisión. No la modificamos ni continuamos al pago.');
      var signature = stable([correctedProperties(item), item.selling_plan_allocation || null, item.parent_relationship || null]);
      var stale = (item.properties || {}).Entrega !== TEXT;
      if (signatures.has(signature) && (stale || signatures.get(signature))) throw problem('merge_risk', 'Hay dos líneas de Puffer fucsia que podrían unirse al corregir el plazo. No modificamos esas líneas. Revisa el carrito antes de continuar.');
      signatures.set(signature, stale);
    });
  }

  function createController(io) {
    var tail = Promise.resolve();
    var flight = null;
    var aliases = Object.create(null);
    function enqueue(work) {
      var task = tail.then(work);
      tail = task.catch(function () {});
      return task;
    }
    function resolveKey(key) {
      var count = 0;
      while (aliases[key] && count++ < 100) key = aliases[key];
      return key;
    }
    async function run() {
      var cart = await io.getCart();
      preflight(cart);
      var changed = 0;
      var maximum = cart.items.length;
      for (var n = 0; n < maximum; n++) {
        var stale = cart.items.find(function (item) { return isTarget(item) && (item.properties || {}).Entrega !== TEXT; });
        if (!stale) return { cart: cart, changed: changed };
        // Re-read immediately before each write. Ajax Cart has no server-side CAS.
        var fresh = await io.getCart();
        assertCart(fresh);
        if (cartSignature(fresh) !== cartSignature(cart) || !fresh.items.some(function (item) { return item.key === stale.key; })) {
          throw problem('cart_drift', 'El carrito cambió mientras revisábamos el plazo. Vuelve a intentarlo con el carrito actualizado.');
        }
        preflight(fresh);
        var expected = clone(fresh);
        var index = fresh.items.findIndex(function (item) { return item.key === stale.key; });
        expected.items[index].properties = correctedProperties(fresh.items[index]);
        if (io.onChangeStarted) io.onChangeStarted();
        var response = await io.changeItem({
          id: fresh.items[index].key,
          quantity: fresh.items[index].quantity,
          properties: expected.items[index].properties
        });
        assertCart(response);
        var verified = await io.getCart();
        assertCart(verified);
        if (cartSignature(verified) !== cartSignature(expected)) {
          throw problem('verification_failed', 'No pudimos confirmar que el carrito conserve todas sus líneas y condiciones. Revisa el carrito antes de continuar; no repetimos el cambio automáticamente.');
        }
        var replacement = verified.items.find(function (item) { return itemSignature(item) === itemSignature(expected.items[index]); });
        if (replacement && replacement.key !== stale.key) aliases[stale.key] = replacement.key;
        changed++;
        cart = verified;
        if (io.onCorrected) io.onCorrected(cart);
      }
      if (cart.items.some(function (item) { return isTarget(item) && (item.properties || {}).Entrega !== TEXT; })) {
        throw problem('unstable_cart', 'El carrito cambió durante la revisión. Vuelve a intentarlo.');
      }
      return { cart: cart, changed: changed };
    }
    return {
      sanitize: function () {
        if (flight) return flight;
        flight = enqueue(run);
        var current = flight;
        current.then(function () { if (flight === current) flight = null; }, function () { if (flight === current) flight = null; });
        return current;
      },
      coordinate: enqueue,
      resolveKey: resolveKey
    };
  }

  // This gate is independently testable. Confirming does not resume until a fresh
  // read verifies that no new correction is needed while the notice was open.
  function createGate(controller, state, confirm, present) {
    var flight = null;
    return function (resume) {
      if (flight) return flight;
      flight = (async function () {
        for (var attempt = 0; attempt < 3; attempt++) {
          var result = await controller.sanitize();
          if (result.changed) state.setPending(true);
          if (!result.cart.items.some(isTarget)) state.setPending(false);
          present(result.cart);
          if (state.getPending()) {
            if (!await confirm()) return false;
            state.setPending(false);
            continue;
          }
          await resume();
          return true;
        }
        throw problem('repeated_change', 'El plazo volvió a cambiar. Revisa el carrito antes de continuar.');
      })();
      var current = flight;
      current.then(function () { if (flight === current) flight = null; }, function () { if (flight === current) flight = null; });
      return current;
    };
  }

  function prepareAddData(data) {
    if (String(data.get('id')) === VARIANT) data.set('properties[Entrega]', TEXT);
    return data;
  }
  function variantURL(productURL, id, currentURL) {
    var current = new URL(currentURL);
    var url = new URL(productURL, current.origin);
    // Public variant navigation carries only the selected variant and campaign fields.
    // Preview/private query parameters and fragments are not forwarded.
    url.search = '';
    url.hash = '';
    url.searchParams.set('variant', id);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'fbclid'].forEach(function (key) {
      var value = current.searchParams.get(key);
      if (value) url.searchParams.set(key, value);
    });
    return url.toString();
  }
  function reconcileRows(cart, rows, resolveKey) {
    if (rows.length !== cart.items.length) throw problem('view_changed', 'Tu bolsa cambió. Recárgala para revisar tu selección antes de continuar.');
    var byKey = new Map(rows.map(function (row) { return [resolveKey(row.key), row]; }));
    if (byKey.size !== rows.length) throw problem('view_changed', 'Tu bolsa cambió. Recárgala antes de continuar.');
    return cart.items.map(function (item) {
      var row = byKey.get(item.key);
      if (!row || String(row.variantId) !== String(item.variant_id || item.id)) throw problem('view_changed', 'Tu bolsa cambió. Recárgala antes de continuar.');
      if (String(row.value).trim() === '') throw problem('quantity_invalid', 'Revisa la cantidad elegida antes de continuar.');
      var quantity = Number(row.value);
      if (!Number.isInteger(quantity) || quantity < 0 || quantity > 99) throw problem('quantity_invalid', 'Revisa la cantidad elegida antes de continuar.');
      var edited = quantity !== Number(row.serverQuantity);
      if (edited && Number(row.serverQuantity) !== item.quantity) throw problem('quantity_changed', 'La cantidad de esta variante cambió. Recarga tu bolsa para revisarla.');
      return { row: row, key: item.key, serverQuantity: item.quantity, value: edited ? quantity : item.quantity };
    });
  }

  function mount(win) {
    var doc = win.document;
    var nativeCart = doc.getElementById('native-cart');
    var pending = false;
    var bypass = null;
    var bypassLink = null;
    var actionFlight = null;
    try { pending = win.sessionStorage.getItem(PENDING_KEY) === '1'; } catch (_) {}
    var state = {
      getPending: function () { return pending; },
      setPending: function (next) {
        pending = next;
        try { if (next) win.sessionStorage.setItem(PENDING_KEY, '1'); else win.sessionStorage.removeItem(PENDING_KEY); } catch (_) {}
      }
    };
    function endpoint(path) { return (win.Shopify && win.Shopify.routes ? win.Shopify.routes.root : '/') + path; }
    function viewURL(path) {
      var url = new win.URL(endpoint(path), win.location.origin);
      var preview = new win.URL(win.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.toString();
    }
    async function request(path, data) {
      var abort = new win.AbortController();
      var timer = win.setTimeout(function () { abort.abort(); }, 12000);
      var options = { credentials: 'same-origin', cache: 'no-store', signal: abort.signal, headers: { Accept: 'application/json' } };
      if (data) {
        options.method = 'POST';
        if (data instanceof win.FormData) options.body = data;
        else { options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(data); }
      }
      try {
        var response = await win.fetch(endpoint(path), options);
        var json = await response.json();
        if (!response.ok) throw problem('cart_request', json.description || 'No pudimos actualizar tu bolsa. Vuelve a intentarlo.');
        return json;
      } catch (error) {
        if (error.code) throw error;
        throw problem('cart_network', 'No pudimos revisar tu bolsa. Vuelve a intentarlo antes de continuar.');
      } finally { win.clearTimeout(timer); }
    }
    function status(message) {
      var node = doc.querySelector('[data-b-cart-status]') || doc.querySelector('[data-add-status]');
      if (node) { node.textContent = message || ''; node.hidden = !message; }
    }
    function syncRows(cart) {
      if (!nativeCart) return;
      var rows = Array.from(nativeCart.querySelectorAll('[data-b-cart-line]')).map(function (node) {
        var input = node.querySelector('[name="updates[]"]');
        return { node: node, input: input, key: node.dataset.lineKey, variantId: node.dataset.variantId,
          serverQuantity: node.dataset.serverQuantity, value: input.value };
      });
      var resolved = reconcileRows(cart, rows, controller.resolveKey);
      var list = nativeCart.querySelector('.cart-lines');
      resolved.forEach(function (entry) {
        var row = entry.row;
        row.node.dataset.lineKey = entry.key;
        row.node.dataset.serverQuantity = String(entry.serverQuantity);
        row.input.value = String(entry.value);
        var remove = row.node.querySelector('[data-remove-key]');
        if (remove) remove.dataset.removeKey = entry.key;
        // Keep native updates[] in the server's order without rebuilding lines.
        list.appendChild(row.node);
        if (String(row.variantId) === VARIANT) row.node.querySelectorAll('[data-b-delivery-property]').forEach(function (node) { node.textContent = 'Entrega: ' + TEXT; });
      });
    }
    function present(cart) {
      syncRows(cart);
      if (cart.items.some(isTarget) && pending) status('Actualizamos el plazo de Puffer fucsia. ' + TEXT);
      else status('');
    }
    function promptNotice(error) {
      return new Promise(function (resolve) {
        var dialog = doc.createElement('dialog');
        dialog.className = 'b-cart-dialog';
        dialog.setAttribute('aria-label', error ? 'Revisa tu bolsa' : 'Plazo actualizado de Puffer fucsia');
        dialog.style.cssText = 'width:min(90vw,36rem);max-height:85vh;overflow:auto;padding:24px;border:1px solid currentColor;background:#fff;color:#171717;line-height:1.5;';
        var heading = doc.createElement('h2');
        heading.textContent = error ? 'Revisa tu bolsa' : 'Actualizamos el plazo de Puffer fucsia';
        var text = doc.createElement('p'); text.textContent = error ? error.message : TEXT;
        dialog.appendChild(heading); dialog.appendChild(text);
        function close(result) { if (dialog.open) dialog.close(); dialog.remove(); resolve(result); }
        if (!error) {
          var proceed = doc.createElement('button'); proceed.type = 'button'; proceed.className = 'primary';
          proceed.textContent = 'He leído el plazo. Continuar'; proceed.addEventListener('click', function () { close(true); });
          dialog.appendChild(proceed);
        }
        var back = doc.createElement('button'); back.type = 'button'; back.className = 'text-link'; back.style.margin = '16px 0 0';
        back.textContent = 'Volver a la bolsa'; back.addEventListener('click', function () { close(false); }); dialog.appendChild(back);
        dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(false); });
        doc.body.appendChild(dialog); dialog.showModal(); back.focus();
      });
    }
    var controller = createController({
      getCart: function () { return request('cart.js'); },
      changeItem: function (payload) { return request('cart/change.js', payload); },
      onChangeStarted: function () { state.setPending(true); }
    });
    var gate = createGate(controller, state, function () { return promptNotice(); }, present);
    function act(work) {
      if (actionFlight) return actionFlight;
      actionFlight = Promise.resolve().then(work).catch(function (error) { status(error.message); return promptNotice(error); });
      var current = actionFlight;
      current.then(function () { if (actionFlight === current) actionFlight = null; });
      return current;
    }
    function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
    function nativeSubmit(form, submitter) {
      bypass = form;
      form.requestSubmit(submitter);
      bypass = null;
    }
    // One delegated submit listener; B does not instantiate Impulse CartForm.
    win.addEventListener('submit', function (event) {
      var form = event.target;
      if (bypass === form) { bypass = null; return; }
      if (form === nativeCart) {
        var submitter = event.submitter;
        var checkout = submitter && submitter.name === 'checkout';
        if (checkout && nativeCart.dataset.checkoutEnabled !== 'true') { stop(event); status('El pago no está disponible en esta vista.'); return; }
        stop(event);
        act(async function () {
          if (checkout) return gate(function () { nativeSubmit(form, submitter); });
          var result = await controller.sanitize();
          if (result.changed) state.setPending(true);
          present(result.cart);
          nativeSubmit(form, submitter);
        });
      } else if (form && form.matches && form.matches('[data-native-add]')) {
        stop(event);
        act(async function () {
          var button = form.querySelector('button[type="submit"]');
          if (button) button.disabled = true;
          status('Agregando a tu bolsa…');
          try {
            var data = prepareAddData(new win.FormData(form));
            await controller.coordinate(function () { return request('cart/add.js', data); });
            win.location.assign(viewURL('cart'));
          } finally { if (button) button.disabled = false; }
        });
      }
    }, true);
    win.addEventListener('click', function (event) {
      var element = event.target && event.target.closest ? event.target : null;
      if (!element) return;
      var remove = element.closest('[data-remove-key]');
      if (remove) {
        stop(event);
        act(async function () {
          remove.disabled = true;
          try {
            await controller.coordinate(async function () {
              var cart = await request('cart.js');
              var key = controller.resolveKey(remove.dataset.removeKey);
              if (!cart.items.some(function (item) { return item.key === key; })) throw problem('line_changed', 'Tu bolsa cambió. Recárgala antes de quitar esta variante.');
              await request('cart/change.js', { id: key, quantity: 0 });
            });
            win.location.reload();
          } finally { remove.disabled = false; }
        });
        return;
      }
      var link = element.closest('a[href]');
      if (!link || link === bypassLink) return;
      var url = new win.URL(link.href, win.location.href);
      if (url.origin !== win.location.origin || !/\/checkouts?(?:\/|$)/.test(url.pathname)) return;
      stop(event);
      if (!doc.querySelector('[data-commercial-native]')) { status('El pago no está disponible en esta vista.'); return; }
      act(function () { return gate(function () { bypassLink = link; link.click(); bypassLink = null; }); });
    }, true);

    var nav = doc.getElementById('main-nav'), menu = doc.querySelector('.menu-toggle');
    if (menu && nav) menu.addEventListener('click', function () {
      var open = menu.getAttribute('aria-expanded') !== 'true';
      menu.setAttribute('aria-expanded', String(open)); nav.classList.toggle('is-open', open);
    });
    doc.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu && nav) { menu.setAttribute('aria-expanded', 'false'); nav.classList.remove('is-open'); }
    });
    var select = doc.getElementById('variant-select');
    if (select) select.addEventListener('change', function () { win.location.assign(variantURL(select.dataset.productUrl, select.value, win.location.href)); });
    var gallery = doc.querySelector('[data-product-gallery]');
    if (gallery) {
      var productImage = doc.getElementById('primary-product-image');
      var galleryDialog = doc.getElementById('reval-gallery-dialog');
      var zoomTrigger = gallery.querySelector('[data-gallery-zoom]');
      var enlarged = galleryDialog && galleryDialog.querySelector('[data-gallery-enlarged]');
      var original = galleryDialog && galleryDialog.querySelector('[data-gallery-original]');
      var chosen = gallery.querySelector('[data-gallery-view][aria-pressed="true"]');
      var zoomSource = chosen ? chosen.dataset.gallerySrc : (productImage && (productImage.dataset.galleryOriginal || productImage.src));
      function updateZoom() {
        if (!productImage || !zoomSource) return;
        if (enlarged) { enlarged.src = zoomSource; enlarged.alt = productImage.alt; }
        if (original) original.href = zoomSource;
      }
      gallery.querySelectorAll('[data-gallery-view]').forEach(function (button) {
        button.addEventListener('click', function () {
          if (!productImage || !button.dataset.gallerySrc) return;
          // A view changes only media. The purchase selection and URL remain intact.
          productImage.removeAttribute('srcset');
          productImage.removeAttribute('sizes');
          productImage.src = button.dataset.gallerySrc;
          productImage.alt = button.dataset.galleryAlt || productImage.alt;
          zoomSource = button.dataset.gallerySrc;
          gallery.querySelectorAll('[data-gallery-view]').forEach(function (node) { node.setAttribute('aria-pressed', String(node === button)); });
          if (galleryDialog && galleryDialog.open) updateZoom();
        });
      });
      if (zoomTrigger && galleryDialog && productImage) {
        zoomTrigger.addEventListener('click', function () {
          if (typeof galleryDialog.showModal !== 'function') {
            win.open(zoomSource, '_blank', 'noopener');
            return;
          }
          updateZoom();
          if (!galleryDialog.open) galleryDialog.showModal();
        });
        var closeGallery = galleryDialog.querySelector('[data-gallery-close]');
        if (closeGallery) closeGallery.addEventListener('click', function () { galleryDialog.close(); });
        galleryDialog.addEventListener('close', function () { zoomTrigger.focus(); });
      }
    }
    function passiveCheck() {
      if (!nativeCart) return;
      controller.sanitize().then(function (result) {
        if (result.changed) state.setPending(true);
        present(result.cart);
      }).catch(function (error) { status(error.message); });
    }
    if (nativeCart) passiveCheck();
    win.addEventListener('pageshow', function (event) { if (event.persisted) passiveCheck(); });
  }
  return { variantId: VARIANT, text: TEXT, isTarget: isTarget, correctedProperties: correctedProperties,
    cartSignature: cartSignature, createController: createController, createGate: createGate,
    prepareAddData: prepareAddData, reconcileRows: reconcileRows, variantURL: variantURL, mount: mount };
});
